import { render, staticRenderFns } from "./TicketsArchiveCollaborator.vue?vue&type=template&id=7d96dc07&scoped=true"
import script from "./TicketsArchiveCollaborator.vue?vue&type=script&lang=js"
export * from "./TicketsArchiveCollaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96dc07",
  null
  
)

export default component.exports